export const otpColumns = [
    {
        name: "Id",
        selector: (row) => row["id"],
        sortable: true,
        // center: true,
        width: "60px"
    },
    {
        name: "Device Id",
        selector: (row) => row["deviceId"],
        sortable: true,
        // center: true,
        width: "180px"
    },
    {
        name: "Device Type",
        selector: (row) => row["deviceType"],
        sortable: true,
        // center: true,
        // width: "100px"
    },
    {
        name: "Mobile",
        selector: (row) => row["mobile"],
        sortable: true,
        // center: true,
        // width: "150px"
    },
    {
        name: "OTP",
        selector: (row) => row["otp"],
        sortable: true,
        // center: true,
        width: "70px"
    },
    {
        name: "Requested On",
        selector: (row) => row["requestedOn"],
        sortable: true,
        // center: true,
        width: "150px"
        
    },
    {
        name: "Valid Upto",
        selector: (row) => row["validUpto"],
        sortable: true,
        // center: true,
        
    },
];